<template>
  <div id="app">
    <!--路由占位符-->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
  export default {
    name: 'app',
    provide () {
      return {
        reload: this.reload
      }
    },
    data () {
      return {
        isRouterAlive: true
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false
        this.$nextTick(() => this.isRouterAlive = true)
      }
    }
  }
</script>
<style lang="scss">
</style>
